<template>
    <v-form
        ref="form"
        @submit.prevent="send"
    >
        <div class="py-4">
            <h1 class="h2 text-regular">
                {{ $t('profileRemoveAccount.title') }}
            </h1>
        </div>

        <v-layout
            justify-space-between
            py-4
        >
            <v-flex
                shrink
            >
                <v-btn
                    text
                    color="primary"
                    :to="{name: $options.ROUTE.PROFILE}"
                    exact
                >
                    {{ $t('profile.back') }}
                </v-btn>
            </v-flex>

            <v-flex
                shrink
            >
                <v-btn
                    rounded
                    color="secondary"
                    type="submit"
                    :loading="isLoading"
                    :disabled="isLoading"
                >
                    {{ $t('profileRemoveAccount.submit') }}
                </v-btn>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { ROUTE } from '@/js/constants/route';
import { API } from '@/js/constants/api';
import loadUser from '@/js/mixins/loadUser';

export default {
    ROUTE,

    mixins: [
        loadUser,
    ],
    data() {
        return {
            value: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapState('user', [
            'user',
        ]),
    },
    methods: {
        onUserLoad() {
            this.$store.dispatch('doAlert', {
                type: 'success',
                text: this.$t('profile.successfullyChanged'),
            });
            this.$router.push({ name: ROUTE.PROFILE });
        },
        send() {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;

            axios({
                url: API.USER,
                method: 'delete',
            })
                .then(() => {
                    if (this.$route.name === ROUTE.PROFILE_REMOVE_ACCOUNT) {
                        this.$store.dispatch('user/doLogout');
                        this.$store.dispatch('doAlert', {
                            type: 'success',
                            text: this.$t('profileRemoveAccount.alertMessage'),
                            multi: true,
                            html: true,
                            timeout: 0,
                        });
                        this.$store.dispatch('user/doLogout', this.$t('user.successfulLogout'));
                        this.$router.push({ name: ROUTE.LOGIN });
                        return;
                    }

                    this.loadUser(this.onUserLoad);
                })
                .catch((error) => {
                    this.$store.dispatch('doAlert', {
                        text: this.errorMessage(error),
                        type: 'error',
                    });
                    this.isLoading = false;
                });
        },
    },
};
</script>
